import { AddNewWorkspaceConnectionsViewProps } from "src/components/views/workspaces/workspaceConnections/connectionTypes/WorkspaceConnectedItemTypeConfiguration.ts";
import { ServerSideDataGridModel } from "src/components/common/dataGrid/gridModel/ServerSideDataGridModel.tsx";
import { ProductChangeQueryApi } from "src/api/generated/erp/productChanges/api/productChangeQueryApi.ts";
import { AavoDataGrid } from "src/components/common/dataGrid/AavoDataGrid.tsx";
import { ProductChangeView } from "src/api/generated/erp/db/types/tables/productChangeView.ts";
import { enumColumn, integerColumn, textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { AavoTextField } from "src/components/common/inputFields/AavoTextField.tsx";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { faLink } from "@fortawesome/pro-regular-svg-icons";
import { WorkspaceConnectionsApi } from "src/api/generated/workspaces/api/workspaceConnectionsApi.ts";
import { getProductChangeStateLabels } from "src/api/generated/erp/db/types/enums/productChangeState.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const ConnectProductChangesToWorkspaceDataGrid = ({
	workspaceId,
	onCompleted,
}: AddNewWorkspaceConnectionsViewProps) => {
	return (
		<ServerSideDataGridModel
			gridId={"E1A23D0D2C0F0A1B"}
			initialParams={{
				searchQuery: "",
			}}
			fetchData={(params) =>
				ProductChangeQueryApi.getHandlingGridData({
					packageId: null,
					categoryId: null,
					responsiblePersonId: null,
					showCancelled: true,
					searchQuery: params.searchQuery,
					dataModelRequest: params.dataModelRequest,
				})
			}
			getDataModelResult={(data) => data.productChanges}
			getRowId={(row) => row.productChangeId}
			render={({ refreshData, dataGridProps, selectedRows }) => (
				<AavoDataGrid<ProductChangeView>
					columns={[
						integerColumn({ field: "productChangeId", headerName: i18n.t("id"), width: 80 }),
						textColumn({ field: "title", headerName: i18n.t("title"), width: 250 }),
						integerColumn({ field: "packageNo", headerName: i18n.t("change_package"), width: 130 }),
						textColumn({ field: "categoryName", headerName: i18n.t("category"), width: 160 }),
						enumColumn({
							field: "state",
							headerName: i18n.t("state"),
							enumLabels: getProductChangeStateLabels(),
							width: 170,
						}),
					]}
					actionBarComponents={
						<>
							<AavoTextField
								label={i18n.t("search")}
								onSubmit={async (value) => {
									await refreshData({ searchQuery: value });
								}}
							/>
							<AsyncButton
								icon={faLink}
								label={i18n.t("connect")}
								variant={"outlined"}
								disabled={selectedRows.length === 0}
								onClick={async () => {
									await WorkspaceConnectionsApi.insertConnections({
										workspaceId,
										connectedItemIds: selectedRows.map((r) => r.productChangeId),
										connectedItemType: "PRODUCT_CHANGE",
									});
									await onCompleted();
								}}
							/>
						</>
					}
					agentContext={{
						key: defineAgentUiContextKey("workspaces.connectProductChanges.grid"),
						data: {
							workspaceId: workspaceId,
						},
						rowFields: ["productChangeId", "packageId", "title", "state"],
						selectedRowPathSegment: (row) => String(row.productChangeId),
						selectedRowsPathSegment: (count) => i18n.t("product_changes_selected_count", { count }),
					}}
					{...dataGridProps}
				/>
			)}
		/>
	);
};
